import React from "react";
import { useEffect } from "react";
import Header from "./Home/Header";
import { Box } from "@mui/material";
import Skills from "./Home/Skills/Skills";
import AboutMe from "./Home/About/AboutMe";
import ProjectLayout from "./Home/ProjectLayout/ProjectLayout";
import Contact from "./Home/Contact/Contact";
import Footer from "../components/Footer/Footer";
import { animateScroll as scroll } from "react-scroll";
import AOS from "aos";
import "aos/dist/aos.css";
import Experience from "./Home/Experience/Experience";

export default function Home() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <Box className="" style={{ backgroundColor: "#222831" }}>
      <Header />

      <section id="about" data-aos="fade-up" data-aos-duration="3000">
        <AboutMe />
      </section>

      <section id="my_journey" >
        <Experience />
      </section>

      <section id="skills" data-aos="fade-up" data-aos-duration="5000">
        <Skills />
      </section>

      <section id="projects" data-aos="fade-up ">
        <ProjectLayout />
      </section>

      <section id="contacts">
        <Contact />
      </section>

      <Footer />
    </Box>
  );
}
